import { useQuery } from '@apollo/client';
import { GET_ACTIVE_FINAL_EXAM } from '../graphql/getActiveFinalExam';

export const useActiveFinalExam = () => {
  const { data, loading, error, refetch } = useQuery(GET_ACTIVE_FINAL_EXAM);

  return {
    activeFinalExam: data?.getActiveFinalExam,
    hasActiveFinalExam: !!data?.getActiveFinalExam,
    loading,
    error,
    refetch,
  };
};
